import React from "react";
import Widget from "./Widget";
import {
  SubTitle,
  InfoWrapper,
  InfoList,
} from "./Widget.styled";
import { observer } from "mobx-react-lite";
import NoDataAvailable from "./NoDataAvailable";
import { useStore } from "../../../../../hooks";
import Spinner from "../../../../../components/common/Spinner";
import { MemberRoleMapping } from "../../../../../utils/enums";

const DealershipTeam = observer(() => {
  const { unifiedCustomerProfileStore } = useStore();

  return (
    <Widget title="Dealership Team" height="175px">
      {unifiedCustomerProfileStore.isLoading ? (
        <Spinner />
      ) : (
        <InfoWrapper>
          {!unifiedCustomerProfileStore.dealershipTeamData.length ? (
            <NoDataAvailable />
          ) : (
            <InfoList>
              {unifiedCustomerProfileStore.dealershipTeamData.map(member => (
                <li>
                  <SubTitle>{MemberRoleMapping[member.role] || member.role}:</SubTitle>
                  <span>{member.name}</span>
                </li>
              ))}
            </InfoList>
          )}
        </InfoWrapper>
      )}
    </Widget>
  );
});

export default DealershipTeam;
